// 將字串跳脫成可安全放進 HTML 的純文字
//
// 只有「必須交給第三方套件以 innerHTML 渲染」的使用者內容才需要用這個
// （例如 lightGallery 的 subHtml）；一般 JSX 由 React 自動跳脫，不要重複套用。
const HTML_ENTITIES = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
};

export const escapeHtml = (text) => text.replace(/[&<>"']/g, (char) => HTML_ENTITIES[char]);
